class PatientListParamsMapper {
  toPersistence(domainData) {
    const handleStatus = status => {
      if (status === 'Pendente') {
        return 'PENDENTE_ATIVACAO'
      } else {
        return status?.toUpperCase()
      }
    }

    return {
      pagina: domainData?.page,
      itensPorPagina: domainData?.itemsPerPage,
      termo: domainData?.term,
      idsClinicas: domainData?.clinics?.map(clinic => clinic?.id),
      titularidade: domainData?.ownership?.toUpperCase(),
      statusPaciente: domainData?.status?.map(status => handleStatus(status)),
      statusUsuario: domainData?.situation?.toUpperCase(),
    }
  }
}

export default new PatientListParamsMapper()
